import { List } from 'lucide-react';
import type { ListBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const listConfig: BlockTypeConfig<ListBlock> = {
  type: 'list',
  label: 'List',
  description: 'Ordered or unordered list with text or download items',
  icon: List,
  category: 'text',
  createDefault: () => ({
    listType: 'ul',
    items: [
      { id: crypto.randomUUID(), type: 'text', content: 'First item' },
      { id: crypto.randomUUID(), type: 'text', content: 'Second item' },
    ],
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.listType',
      label: 'Type',
      options: [
        { value: 'ul', label: 'Bullets' },
        { value: 'ol', label: 'Numbered' },
        { value: 'none', label: 'None' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [{ kind: 'text', path: 'data.title', label: 'Title' }],
  repeatingItems: {
    arrayPath: 'data.items',
    itemFactory: () => ({ id: crypto.randomUUID(), type: 'text', content: 'New item' }),
    addLabel: 'Add item',
  },
};
